(function () {
    'use strict';

    const module = angular.module('uwAgenda.agenda');

    // directive for one the appointment types dropdown 
    module.directive('agendaAppointmentTypes', ['$compile', 'ProtocolBroadcastService', function ($compile, ProtocolBroadcastService) {
        const directive = {
            restrict: 'E',
            templateUrl: '/app/agenda/templates/agenda-appointment-types.template.html',
            scope: {
                model: '=', // the current selected item
                types: '=', // list of possible appointment-types
                label: '=', // the selected agenda-label
                onChange: '=?',
                showProtocol: '=',
                required: '=?',
                darkenUnlinked: '=?',
            },
            link: link
        };
        return directive;

        function link(scope, element) {
            const current = element.find('#current');
            let labelWatcher = null;
            scope.typeNotLinkedToLabel = false;

            activate();

            if (scope.required === undefined) {
                scope.required = true; 
            }

            // activate
            function activate() {

                // watch on label-change
                if (scope.showProtocol) {
                    labelWatcher = scope.$watch(function () {
                        return scope.label;
                    }, function (newVal, oldVal) {
                        finding(newVal);
                    });
                }

            } // activate

            // select item
            function select(item, manualSelection) {
                if (item === undefined || item === null) {
                    return;
                }

                scope.typeNotLinkedToLabel = !!(manualSelection &&
                    scope.label &&
                    scope.label.agendaLabelText &&
                    item.agendaLabelCaption !== scope.label.agendaLabelText);

                scope.model = item;
                // remove "existing"
                delete scope.model.existing;
                // compile appointment-type-directive
                current.find('> span:first').remove();
                // new element
                let el = $compile("<span agenda-appointment-type appointment-type='model'></span>")(scope);
                current.prepend(el);
                el = null;

                if (scope.showProtocol) {
                    // protocol to show depending on appointment-type ?
                    ProtocolBroadcastService.broadcast(null, scope.model.id);                    
                }

                if (scope.onChange) {
                    scope.onChange(item);
                }
            }

            // select another item
            scope.select = function (item) {
                select(item, true);
            };

            scope.reset = function () {
                scope.typeNotLinkedToLabel = false;

                const emptyAppointmentType = {
                    id: null,
                    colorCaption: 'white',
                    text: '',
                    agendaLabelCaption: ''
                };

                scope.model = emptyAppointmentType;

                // Compile appointment-type-directive with empty model
                current.find('> span:first').remove();
                let el = $compile("<span agenda-appointment-type appointment-type='model'></span>")(scope);
                current.prepend(el);
                
                if (scope.onChange) {
                    scope.onChange(emptyAppointmentType);
                }

                // if we are showing a protocol, also clear that
                if (scope.showProtocol) {
                    ProtocolBroadcastService.broadcast(null, null);
                }
            };

            // find by selected label
            function finding(label) {
                let found = false;
                let i = 0;
                const len = scope.types.length;
                // if "EDIT" -> show appointment-type of existing appointment
                if (scope.model.existing) {
                    // iterator over types
                    for (i = 0; i < len; i++) {
                        if (scope.types[i] === null) { continue; }
                        // Prefer matching both type and current label because a type can exist in multiple labels.
                        if (scope.model.id === scope.types[i].id &&
                            (!label || !label.agendaLabelId || scope.types[i].agendaLabelId === label.agendaLabelId)) {
                            select(scope.types[i]);
                            found = true;
                            break;
                        } // if
                    } // for

                    // fallback: keep legacy behavior if no label-specific match was found
                    if (!found) {
                        for (i = 0; i < len; i++) {
                            if (scope.types[i] === null) { continue; }
                            if (scope.model.id === scope.types[i].id) {
                                select(scope.types[i]);
                                found = true;
                                break;
                            }
                        }
                    }
                } // if
                else {
                    // "New" Appointment -> so find Type by selected agenda-label
                    if (typeof label !== 'undefined' && label !== null) {
                        // iterate over types
                        for (i = 0; i < len; i++) {
                            if (scope.types[i] === null) { continue; }
                            // find by agenda-label-id 
                            if (scope.types[i].agendaLabelId === label.agendaLabelId) {
                                select(scope.types[i]);
                                found = true;
                                break;
                            } // if
                        } // for
                    } // if
                } // else

                // if no related type was found -> select first in list (default)
                if (!found) {
                    // select first from list (default)
                    select(scope.types[0]);
                } // if
            } // finding


            if (scope.showProtocol) {
                // destroy
                scope.$on("$destroy", function () {
                    labelWatcher();
                    labelWatcher = null;
                });
            }
        }
    }]);

})();